import { usePartnersList } from "./";

export const useGetPartnerByKey = (key: string) => {
  const { partnerList, loading } = usePartnersList();
  const partner = partnerList.find((partner) => partner.key === key);

  return {
    partner: partner,
    loading,
  };
};
